import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="not-found-container">
      <div>
        {/* App Logo */}
        <div className="not-found-logo">
          <img
            src="/favicon.png"
            alt="Phomo Logo"
          />
        </div>

        {/* 404 Error Content */}
        <div className="not-found-content">
          <div className="not-found-error-code">
            404
          </div>

          <h1 className="not-found-title">
            Page Not Found
          </h1>

          <p className="not-found-description">
            Sorry, we couldn't find the page you're looking for.
            The page might have been moved, deleted, or the URL might be incorrect.
          </p>

          {/* Action Button */}
          <button
            onClick={handleGoHome}
            className="not-found-home-button"
          >
            <span className="emoji">🏠</span>
            Go Home
          </button>
        </div>
      </div>

      {/* Footer */}
      <div className="not-found-footer">
        <div>
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
          <a href="/support">Support</a>
        </div>
        © 2025 PhomoCam. Share memories, not just photos.
      </div>
    </div>
  );
};

export default NotFound;